import { useEffect, useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { FormikContextType, FormikProvider, useFormik } from 'formik';
import useDeclarations from 'hooks/useDeclarations';
import { DeclarationExternalEntity } from 'store/declarations/enums/common/declaration-external-entity';
import { useDeclarationContext } from 'views/declarations/common/DeclarationContext';
import ICS2ENSHouseConsignmentForm from 'views/declarations/eu/ics2/ICS2ENSHouseConsignmentForm';

const HouseConsignmentForm = () => {
    const context = useHouseConsignmentView();
    const { declaration } = useDeclarations();

    const { setForm } = useDeclarationContext();

    const mockFormik = useFormik({
        initialValues: {},
        onSubmit: () => {},
    });

    useEffect(() => {
        setForm?.('house-consignment' as any);
    }, [setForm]);

    const formik = useMemo(
        () => context?.houseConsignmentFormik || mockFormik,
        [context?.houseConsignmentFormik, mockFormik]
    );

    const form = useMemo(() => {
        if (!declaration || !formik) return null;

        // Note: Handle other house consignment forms when necessary
        switch (declaration.declarationExternalEntity) {
            case DeclarationExternalEntity.ICS2: {
                return <ICS2ENSHouseConsignmentForm formik={formik} viewOnly={context?.viewOnly} />;
            }

            default:
                return null;
        }
    }, [context?.viewOnly, declaration, formik]);

    if (!context || !context.houseConsignmentFormik) return null;

    return <FormikProvider value={context.houseConsignmentFormik}>{form}</FormikProvider>;
};

export default HouseConsignmentForm;

export function useHouseConsignmentView() {
    return useOutletContext<
        | {
              toggleHelp?: (refNumber: string | number) => void;
              viewOnly?: boolean;
              productTemplate?: boolean;
              selectCard?: (id: string) => void;
              cancelFetchProduct?: boolean;
              houseConsignmentFormik?: FormikContextType<any>;
          }
        | undefined
    >();
}
